// components/OutputVisualization.jsx
"use client";

import React, { useState } from 'react';
import CircleSequence from './CircleSequence';



const OutputVisualization = ({
  sequence,
  positionToShow=0
}) => {
  const [sequenceInput, setSequenceInput] = useState('');
  const [lineWidth,setLineWidth]=useState(0.19)
  const [percentToShow,setPercentToShow]=useState(100)

  return (
    <div className="flex-1 bg-white shadow-lg rounded-2xl w-full flex flex-col ">
      {/* Circle Sequence Visualization */}
      <div className="w-full flex justify-center">
        <CircleSequence
          sequence={sequence}
          totalPoints={250}
          lineWidth={lineWidth}
          positionToShow={positionToShow}
          percentToShow={percentToShow}
        />
      </div>
      <div className="space-y-4  p-6 bg-gray-800 text-white rounded-b-2xl">
        {/* Line Width Control */}
        <div>
          <label htmlFor="line-width" className="block text-sm font-medium text-white mb-1 flex items-center">
            <span className="mr-2">📏 Grosor de la línea</span>
            <span className="ml-auto text-xs text-white">{lineWidth.toFixed(2)}px</span>
          </label>
          <input
            type="range"
            id="line-width"
            min="0.01"
            max="0.5"
            step="0.01"
            value={lineWidth}
            onChange={(e) => setLineWidth(Number(e.target.value))}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default OutputVisualization;
